var $ = jQuery.noConflict();

function smoothScrollTo(sel, offset) {
    $('html, body').animate({
        scrollTop: $(sel).offset().top + offset
    }, 500, 'swing');
}

/* Srcset implementation for background-image */

function imageCurrentSrc(el) {
    var img = $(el);
    return typeof img.prop('currentSrc') !== 'undefined' ? img.prop('currentSrc') : img.attr('src');
}

function imageToBackgroundImage(e) {
    var img = e instanceof Event ? e.target : e;
    var container = $(img).parents('.js-bg');
    console.log(container);
    if ($(img).is('.js-bg__img') || container.find('img').length == 1) {
        container.css('background-image', 'url(' + imageCurrentSrc(img) + ')');
        $(img).hide();
    }
}

/* Srcset implementation for background-image */
function switchSrc(el, parent) {
    var src = imageCurrentSrc(el);
    $(el).parents('.' + parent).css('background-image', 'url(' + src + ')').addClass(parent + '--loaded').end().hide();
}

function checkBackgroundImages(params) {
    var parent_selector = 'js-bg';
    $('.' + parent_selector).each(function () {
        var imgs = $(this).find('.js-bg__img').length ? $(this).find('.js-bg__img') : $(this).find('img');
        imgs.on('load', function () {
            switchSrc(this, parent_selector);
        }).each(function () {
            if (this.complete) {
                switchSrc(this, parent_selector);
            }
        });
    });
}

$(function () {
    /* Sliders management */
    var slider_opt = {
        items: 1,
        loop: false,
        dots: false,
        nav: true,
        navElement: 'a',
        navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
        navClass: ['owl-prev', 'owl-next'],
        autoplay: false,
        mouseDrag: false,
        touchDrag: true,
        // autoplayHoverPause: true,
    };

    var sliders = $('.owl-carousel').filter(function () {
        return $(this).find('.slide').length > 1;
    });

    if (sliders.length) {
        sliders.each(function () {
            var slider = $(this);
            var overrided = {}
            switch (true) {
                case slider.is('.slider--portrait'):
                    $.extend(overrided, slider_opt, {
                        center: true,
                        stagePadding: 0,
                        margin: 20,
                        loop: true,
                        //rewind: true,
                        smartSpeed: 500,
                        responsive: {
                            350: {
                                stagePadding: 50,
                            },
                            576: {
                                stagePadding: 75,
                            },
                            768: {
                                stagePadding: 125,
                            },
                            992: {
                                stagePadding: 175,
                            },
                            1300: {
                                stagePadding: 225,
                            }
                        }
                    });
                    break;
                case slider.is('.slider--related'):
                    $.extend(overrided, slider_opt, {
                        center: false,
                        stagePadding: 0,
                        margin: 20,
                        loop: true,
                        //rewind: true,
                        smartSpeed: 500,
                        responsive: {
                            576: {
                                items: 1,
                            },
                            768: {
                                items: 2
                            },
                            992: {
                                items: 3
                            },
                            1300: {
                                items: 4
                            }
                        }
                    });
                    break;
            }
            $.extend(overrided, {
                onInitialized: function(){
                    var sliders = {};
                    $('.owl-item.cloned a').each(function(i, element){
                        $(element).attr('data-fancybox', null);
                        $(element).click(function(event){
                            event.preventDefault();
                            $('.owl-item:not(.cloned)').find('#'+$(element).attr('id')).trigger('click');     
                            return event;
                        });
                    });
                    $('.owl-item:not(.cloned) a').each(function(i,e){
                        var slider_name = $(e).data('fancybox');
                        
                        if ( slider_name != undefined && 
                            undefined == sliders[slider_name] ) {
                            sliders[slider_name] = [];
                        }
                        if ( undefined != sliders[slider_name] ) {
                            sliders[slider_name].push(e);
                        }
                    });
                    for( i in sliders ) {
                        $(sliders[i]).fancybox({/*loop: true*/});
                    }

                    checkBackgroundImages();
                }
            });
            slider.owlCarousel(overrided);
        });
    }
    checkBackgroundImages();
    /* --- */

    $('#search-bar__collapse').on('shown.bs.collapse', function () {
        $(this).find('input[name="s"]').focus();
    });

    /** Header Manager */

    $('#header-navbar').on('hide.bs.collapse', function(e){
        $('.header.js-sticky').addClass('is_stuck');
        $('#sticky-navbar-toggler').show(); //collapse('show');

    });

    $('#header-navbar').on('show.bs.collapse', function(e){
        $('#sticky-navbar-toggler').hide(); //collapse('hide');
        $('#header__collapse').collapse('hide');
        $('.header.js-sticky').removeClass('is_stuck');
    });

    function fix_scroll() {
        var st = $(window).scrollTop();

        if ( st == 0 ) {
            $(window).scrollTop(st+1);
            $(window).scrollTop(st-1);
        }
        else {
            $(window).scrollTop(st+1);
        }
    }

    $(window).on('resize scroll orientationchange', function(e) {
        st = $(window).scrollTop();

        if($(window).width() > 991 ) {
            if ( st == 0 ) {
                $('#sticky-navbar-toggler').hide();//.collapse('hide');
                $('#header-navbar').collapse('show');
            }

            if ( st > 0 ) {
                $('#header-navbar').collapse('hide');
                $('#sticky-navbar-toggler').show();//.collapse('show');
            }
        }

        if ( $(window).width() <= 991 ) {
            $('#sticky-navbar-toggler').show();//.collapse('show');
            $('#header-navbar').collapse('hide');
        }
    });

    fix_scroll();

    /* Loadmore management + Masonry */

    $('.js-loadmore').click(function (e) {
        e.preventDefault();
        
        var self = $(this);

        if (self.is('.disabled')) return;

        var next_page = parseInt(self.data('current-page')) + 1;

        var container = $(self.data('target'));
        //var item = $(self.data('target-item')).first().clone().children().remove().end().hide();

        self.addClass('disabled loading');
        $('#js-filter__target').addClass('loading');
        data = {};
        data.page = next_page;
        if ( taxonomy = $(this).data('taxonomy') ) {
            data.taxonomy = taxonomy;
        }
        if ( tax_slug = $(this).data('slug') ) {
            data.tax_slug = tax_slug;
        }
        $.get(self.data('href'), data, function(response) {
            if (response.contents) {
                var $target = $('#js-filter__target');
                var $template = $($('#js-filter-template').html().trim()); 
                $.each(response.contents, function (i, el) {
                    $t = $template.clone();
                    $t.css('order', i);
                    $t.append($(el));
                    $target.append($t).masonry('appended', $t);
                });

                self.data('current-page', response.current_page || next_page);
                self.data('max-num-pages', response.max_num_pages || response.current_page || next_page);

                if (response.current_page >= response.max_num_pages) {
                    self.removeClass('disabled loading');
                    self.fadeOut();
                } else {
                    self.removeClass('disabled loading');
                    self.fadeIn();
                }
            } else {
                self.removeClass('loading');
                self.addClass('error');
            }
        }).then(function(response) {
            $masonry = $('#js-filter__target');
            $masonry.imagesLoaded(function(){
                $masonry = $masonry.masonry( {itemSelector: '.showcase__item', columnWidth: '.showcase__item', horizontalOrder: true} );
                $masonry.masonry('layout')
            });
        }).then(function() {
            $('#js-filter__target').removeClass('loading');
        });
        return false;
    });

    $('.js-filter a').click(function (e) {
        e.preventDefault();
        $('#js-filter__target').addClass( 'loading' ); 
        $('#js-filter__target').masonry( 'remove', $('#js-filter__target > li') );
        var $this = $(this);
        var $parent = $(this).parent();
        var $load_more_button = $this.parents('section').find('div.section__footer a');
        var taxonomy = $parent.data('taxonomy');
        var tax_slug = $parent.data('slug');
        var page = $parent.data('page');
        $this.parents().find('a.nav-link.active').removeClass('active');
        $this.addClass('active');
        $load_more_button.attr('href', $(this).attr('href'));
        $load_more_button.data('taxonomy', taxonomy);
        $load_more_button.data('slug', tax_slug);
        $load_more_button.data('current-page', page);
        $load_more_button.trigger('click');
        
        $('#js-filter__target').removeClass( 'loading' ); 
        return false;
    });

    /** Masonry Fix */
    $(window).on('resize orientationchange', function() {
        $('.js-masonry').each(function() {
            var $this = $(this);
            $this.masonry('layout');
        });
    });

    $(window).load(function(){
        $('.js-filter__template').remove(); 
        $('.js-masonry').each(function () {
            var $this = $(this);
            $this.imagesLoaded(function(){
                $this.masonry( {itemSelector: '.showcase__item', columnWidth: '.showcase__item', horizontalOrder: true} );
                $this.masonry('layout');
            });
        });
        $('.js-loadmore').trigger('click');
    });

    // setTimeout(function() {
    //     $('#js-filter__target')
    //     $('ul.nav.js-filter li:first-child').find('a').trigger('click');
    // }, 200);

    /* Prevent submit with empty search text */
    $('#searchform').on('submit', function(e) {
        if ( $('input[name=s]').val().length > 0 ) {
            return true;
        }
        e.preventDefault();
        return false;
    });

    /* Back to top management */
    $(window).on('scroll', function () {
        if ($(this).scrollTop() > $(this).height() * .5) {
            $('.back-to-top').addClass('in');
        } else {
            $('.back-to-top').removeClass('in');
        }
    });
    
    $('.back-to-top').click(function (e) {
        e.preventDefault();
        $("html, body").animate({ scrollTop: 0 }, 500, 'swing' );
        return false;
    });

    /* Header animation */
    window.animation_runned = 0;

    function animate_start() {
        if ( window.animation_runned > 2 ) { return false; }
        window.animation_running = true;
        var $animation_logo = $('.animation-logo');
        var $animated = $('.animate');
        var number = $animated.length;
        window.animation_timeout = setTimeout(animate_stop, 1000*number);
        $animation_logo.removeClass('stop');
        $animation_logo.addClass('start');
    }

    function animate_stop() {
        if ( window.animation_runned > 2 ) { return false; }
        window.animation_runned = window.animation_runned + 1;
        var $animation_logo = $('.animation-logo');
        $animation_logo.removeClass('start');
        $animation_logo.addClass('stop');
        clearTimeout(window.animation_timeout);
        window.animation_timeout = false;
        window.animation_running = false;
    }

    setInterval(function(){
        if ( !window.scrolls ) {
            window.scrolls = [];
        }

        window.scrolls.push( $(window).scrollTop() );

        if ( window.scrolls.length > 2 ) {
            window.scrolls = window.scrolls.slice(-2);
        }
        else {
            // non ho dati sufficienti
            return false;
        }
        // La mia pagina è on top 
        var in_top;
        // Mi sono mosso?
        var moved;

        in_top = window.scrolls[1]==0;
        moved = window.scrolls[0] != window.scrolls[1];
        if ( in_top 
                && !moved 
                && !window.animation_running 
                && window.animation_runned == 0 ) {
            window.old_value = window.scrolls[1];
            animate_start();
        }

        if ( !in_top 
                && !moved 
                && !window.animation_running 
                && window.animation_runned < 1
                && !window.animation_timeout ) {
            window.old_value = window.scrolls[1];
            animate_start();
            window.animation_timeout = true;
        }

        if ( !in_top 
                && !moved 
                && !window.animation_running 
                && window.animation_runned < 2 
                && !window.animation_timeout
                && window.old_value != window.scrolls[1] ) {
            
            window.animation_timeout = setTimeout(animate_start, 3000);
        }
        
    }, 100);

    $(window).load(function() { 
        setTimeout(function() {
            $('.js-masonry').each(function() {
                var $this = $(this);
                $this.imagesLoaded(function(){
                    $this.masonry( {itemSelector: '.showcase__item', columnWidth: '.showcase__item', horizontalOrder: true} );
                    $this.masonry('layout');
                    console.log(5000);
                });
            });
        },5000);
        setTimeout(function() {
            $('.js-masonry').each(function() {
                var $this = $(this);
                $this.imagesLoaded(function(){
                    $this.masonry( {itemSelector: '.showcase__item', columnWidth: '.showcase__item', horizontalOrder: true} );
                    $this.masonry('layout');
                    console.log(12000);
                }); 
            });
        },12000);
    });

    $(window).scroll(function() {
        
        if ( window.animation_running == true ) {
            animate_stop();
            return false;
        }
/*
        if ( $(window).scrollTop() == 0 && window.animation_timeout ) {
            clearTimeout(window.animation_timeout);
        }

        if ( $(window).scrollTop() > 100 && window.animation_timeout ) {
            clearTimeout(window.animation_timeout);
        }

        if ( window.animation_running == false &&
            window.animation_runned < 2 &&
            window.animation_timeout ) {
            
        }
        */
    });
});
